<script setup lang="ts">
import { uid } from '../utils'
import { computed, ref } from 'vue'

interface Props {
    id?: string
    name?: string
    value?: boolean
}
const props = withDefaults(defineProps<Props>(), {
    id: undefined,
    name: undefined,
})
const emit = defineEmits<{
    (event: 'update:value', isChecked: boolean): void
}>()

const isChecked = computed(() => props.value)
const handleChange = (e: Event) => emit('update:value', (e.target as HTMLInputElement).checked)

const internalId = ref(props.id || uid())
</script>

<template>
    <label class="checkbox" :for="internalId">
        <span class="flex items-center h-5">
            <input
                :id="internalId"
                :checked="isChecked"
                :name="name"
                type="checkbox"
                class="checkbox__input form-checkbox"
                role="checkbox"
                :aria-checked="isChecked"
                @change="handleChange"
            />
        </span>
        <span class="ml-2 text-sm">
            <span class="checkbox__label">
                <slot></slot>
            </span>
        </span>
    </label>
</template>
